import React from 'react';
import cognososLogo from '../images/Cognosos.png';
import './Logo.css';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`logo-container ${className}`} data-testid="logo">
      <img src={cognososLogo} alt="Cognosos" className="logo-image" />
    </div>
  );
};

export default Logo;
